import * as React from 'react';
import { useState, useEffect } from 'react';
import { formatCurrency } from '../utils';
import { useDispatch, useSelector } from 'react-redux';
import { Product, PurchaseItem } from '../interfaces';

import { AppDispatch } from '../store/store';
import { RootState } from '../store/store';
import { updatePurchaseCartAsync } from '../store/purchaseSlice';
import { setSelectedProduct } from '../store/productSlice';

// import { useNavigate } from 'react-router-dom';

interface ProductCardProps {
  product: Product;
}
const ProductItem: React.FC<ProductCardProps> = ({ product }) => {
  //   const auth_token = useSelector((state: RootState) => state.auth.token);
  const purchaseData = useSelector(
    (state: RootState) => state.purchase.purchase
  );

  const [cart, setCart] = useState<PurchaseItem[]>([]);

  const [existsInCart, setExistInCart] = useState<boolean>(false);
  const [quantity, setQuantity] = useState<number>(0);
  const storeInfo = useSelector((state: RootState) => state.products.storeInfo);
  const dispatch = useDispatch<AppDispatch>();
  //   const navigate = useNavigate()

  const addToCart = async (cartItem: {
    code: string;
    name: string;
    quantity: number;
    productVariantId: number;
    specialRequest: string;
    image: string;
    description: string;
    unitPrice: number;
  }) => {
    // eslint-disable-next-line prefer-const
    let thisCart = [...cart];
    // eslint-disable-next-line prefer-const
    let CartLineItems: PurchaseItem[] = [];
    const {
      quantity,
      productVariantId,
      specialRequest,
      image,
      description,
      code,
      name,
      unitPrice,
    } = cartItem;
    const index = thisCart.findIndex(
      (item) => item.productVariantId === productVariantId
    );
    if (quantity > 0 && index < 0) {
      await thisCart.push({
        unitPrice: unitPrice,
        quantity: 1,
        code: code,
        name: name,
        rewardsValue: 0,
        productVariantId: productVariantId,
        paymentStatus: '',
        specialRequest: specialRequest,
        image: image,
        description: description,
      });
    }
    if (thisCart.length > 0) {
      for (let i = 0; i < thisCart.length; i++) {
        let this_item: PurchaseItem = thisCart[i];
        if (index === i && quantity > 0) {
          this_item = { ...thisCart[i], quantity: thisCart[i].quantity + 1 };
        }
        if ((quantity > 0 && index === i) || index !== i) {
          CartLineItems.push(this_item);
        }
      }
    }
    const purchaseCode = '';
    dispatch(updatePurchaseCartAsync({ CartLineItems, purchaseCode }));
  };

  useEffect(() => {
    if (purchaseData) {
      if (purchaseData.purchases) {
        setCart(purchaseData.purchases);
      }
    } else {
      setCart([]);
    }
  }, [purchaseData]);

  useEffect(() => {
    const variants = product.variants.map((variant) => variant.id);
    let quantity = 0;
    cart.filter((item) => {
      if (variants.includes(item.productVariantId)) {
        quantity += item.quantity;
      }
    });

    setExistInCart(quantity > 0);
    setQuantity(quantity);
  }, [product, cart]);

  const description = product.description?.trim();

  return (
    <>
      <div
        className="flex flex-col w-[150px] md:w-[200px]
        !bg-white rounded-xl p-1 shadow-sm
        cursor-pointer z-1 group rounded-md h-auto
        relative animate__animated animate__fadeIn"
        onClick={() => {
          dispatch(setSelectedProduct(product));
        }}
      >
        {product.isOutOfStock && (
          <div
            className="absolute w-full h-full bg-secondary-500 
          bg-opacity-30 z-10 rounded-xl top-0 left-0"
          >
            <div className="w-full h-full justify-center align-center content-center">
              <div className="w-[150px] p-[10px] text-xl !text-white font-bold text-center m-auto ">
                Sold out
              </div>
            </div>
          </div>
        )}
        {typeof product.images !== 'undefined' && (
          <div className="w-full  relative ">
            {(product.images[0] || storeInfo?.coverImage) && (
              // <Link to={`/product/${product.id}`} className="w-full h-full">
              <div>
                {product.images[0] ? (
                  <img
                    src={`${product.images[0]}`}
                    className="w-full h-[272px] m-auto rounded-xl
                  object-contain object-center bg-white
                  border border-[1px] border-[#DCE0E566] cursor-pointer
                  transition duration-[1000ms] ease-in-out 
                  hover:border-secondary-400 hover:border-[3px]"
                    alt={product.name}
                  />
                ) : (
                  <div
                    className="bg-secondary-200 w-full h-[215px] m-auto 
                  rounded-lg border border-[1px] border-[#DCE0E500] cursor-pointer
                  transition duration-[1000ms] ease-in-out 
                  hover:border-secondary-400 hover:border-[3px]"
                  ></div>
                )}
              </div>
              // </Link>
            )}
          </div>
        )}

        <div className="p-[10px] flex-1 pb-[50px] h-auto relative">
          <div className="relative flex justify-between items-start gap-[8px]">
            <div
              className="font-dmsans font-bold 
              text-[13px]
              mb-[0px] text-black flex-1"
            >
              {product.name}
            </div>
          </div>
          <div className="h-auto flex gap-[10px] flex-wrap">
            {product.categories?.map((category) => (
              <span
                key={category.id}
                className="text-primary-800
              font-bold font-dmsans
              font-dmsans text-[8px]
              "
              >
                {category.name}
              </span>
            ))}
          </div>
          <div
            className="text-[#14181F] text-[11px]
          my-[10px]"
          >
            {(description ?? '').length > 100
              ? `${(description ?? '').slice(0, 100)}...`
              : (description ?? '')}
          </div>
          <div
            className="absolute bottom-[10px] 
            flex flex-row-reverse justify-between left-0 px-[10px] w-full"
          >
            <div>
              <button
                className={`text-white m-auto content-center 
                justify-center
                bg-white px-[7px] py-[7px] cursor-pointer
                rounded-[7px] !outline-none
                flex gap-2 items-center relative
                outline-none hover:!outline-none focus:!outline-none
                border border-[2px]
                transition-all duration-300 ease-in-out
                shadow-[inset_0_-2px_2px_rgba(0,0,0,0.0)]
                hover:shadow-[inset_0_-1px_4px_rgba(0,0,0,0.12)]
                ${
                  existsInCart
                    ? 'border-secondary-500 hover:!border-secondary-700'
                    : 'border-secondary-50 hover:!border-secondary-300'
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  if (product?.variants?.length <= 1) {
                    addToCart({
                      quantity: 1,
                      specialRequest: '',
                      productVariantId:
                        product?.variants?.length && product?.variants[0]?.id,
                      code: product.code,
                      name: product.name,
                      image: product.images[0] ? product.images[0] : '',
                      description: product.description,
                      unitPrice:
                        product?.variants?.length &&
                        product?.variants[0]?.unitPrice,
                    });
                  } else if (
                    product?.variants?.length &&
                    product?.variants?.length > 1
                  ) {
                    dispatch(setSelectedProduct(product));
                  }
                }}
              >
                <img
                  src="/asset/basket.svg"
                  alt=""
                  aria-hidden="true"
                  className="w-[16px] h-[16px]"
                />
                {existsInCart && (
                  <div
                    className="absolute 
                    top-[-8px] right-[-8px] w-auto
                    rounded-full bg-secondary-500
                    !text-white
                    !h-[20px] !w-[20px]
                    "
                  >
                    <div
                      className="text-white text-[10px] 
                    !leading-[20px] font-bold"
                    >
                      {quantity > 9 ? '9+' : quantity}
                    </div>
                  </div>
                )}
              </button>
            </div>

            <div
              className="
            flex flex-col gap-[5px] items-left justify-center
            "
            >
              <div
                className="font-dmsans
                    font-bold text-secondary-500 font-[600]
                    text-[12px] md:text-[14px]"
              >
                {formatCurrency(
                  product?.variants?.length && product?.variants[0]?.unitPrice
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductItem;
